// extracted by mini-css-extract-plugin
module.exports = {"workCalendarDialog":"WorkCalendar_workCalendarDialog__1TKxH"};